import { render } from "./Data.vue?vue&type=template&id=c857f47e"
import script from "./Data.vue?vue&type=script&lang=ts"
export * from "./Data.vue?vue&type=script&lang=ts"

import "./Data.vue?vue&type=style&index=0&id=c857f47e&lang=less"
script.render = render

export default script